import {
  Button,
  Card,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Typography,
} from '@mui/material';
import {
  ScreenError,
  ScreenWrap,
  SearchInput,
  SoloLoading,
} from '../../components';
import B2BOrganisationsRow from './B2BOrganisationsRow';
import useModifiableParams from '../../hooks/use-modifiable-params';
import { Add } from '@mui/icons-material';
import { Api } from '../../api';

export default function B2BOrganisationsListScreen() {
  const {
    getParams,
    setModifiedParams,
    tablePaginationProps,
    tableSortLabelProps,
  } = useModifiableParams();

  const params = getParams();

  const api = Api.Organisation.useReadCollection(params as any);

  return (
    <ScreenWrap>
      <Stack spacing={3} alignItems="stretch">
        <Typography variant="h4" component="h1">
          B2B Organisations
        </Typography>
        <Stack
          direction="row"
          alignItems="end"
          spacing={2}
          sx={{ width: '100%' }}
        >
          <SearchInput
            label="Search"
            value={params.name || ''}
            onChange={(e) =>
              setModifiedParams({ name: e.target.value, page: '1' })
            }
            placeholder="Search by name"
          />
          <Button variant="contained" startIcon={<Add />} href="/b2b/new">
            Create
          </Button>
        </Stack>

        <Stack spacing={2}>
          <Card>
            {api.error ? (
              <ScreenError {...api} />
            ) : api.data?.member ? (
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Name</TableCell>
                      <TableCell>Licences</TableCell>
                      <TableCell>Claimed Licences</TableCell>
                      <TableCell>
                        <TableSortLabel {...tableSortLabelProps('createdAt')}>
                          Created At
                        </TableSortLabel>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {api.data.member.map((organisation) => (
                      <B2BOrganisationsRow
                        key={organisation.id}
                        organisation={organisation}
                      />
                    ))}
                  </TableBody>
                  <TableFooter
                    sx={{
                      borderTop: '1px solid rgba(224, 224, 224, 1)',
                    }}
                  >
                    <TableRow>
                      <TablePagination
                        {...tablePaginationProps({
                          totalItems: api.data?.totalItems ?? 0,
                          rowsPerPage: 10,
                        })}
                        count={api.data?.totalItems ?? 0}
                        colSpan={4}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            ) : (
              <SoloLoading />
            )}
          </Card>
        </Stack>
      </Stack>
    </ScreenWrap>
  );
}
